import type { Column } from "@shared/types/data-table"
import type { Inventory } from "@features/in-stores/types/inventory.types"
import type { ColumnManagementConfig } from "@shared/lib/tables/utils/column-management"
import { 
  createTruncatedColumn,
  createDateColumn
} from "./column-factories"

export const INVENTORY_COLUMNS: Record<string, Column<Inventory>> = {
  model: createTruncatedColumn<Inventory>(
    "model",
    "Model",
    140,
    (inventory) => inventory.model,
    "font-medium"
  ),
  order: createTruncatedColumn<Inventory>(
    "order",
    "Order",
    140,
    (inventory) => inventory.order,
    "font-mono text-sm"
  ),
  serialNumber: createTruncatedColumn<Inventory>(
    "serialNumber",
    "Serial Number",
    140,
    (inventory) => inventory.serialNumber,
    "font-mono text-sm"
  ),
  store: createTruncatedColumn<Inventory>(
    "store",
    "Store",
    140,
    (inventory) => inventory.store
  ),
  ordered: createDateColumn<Inventory>("ordered", "Ordered", 140),
  fulfilled: createDateColumn<Inventory>("fulfilled", "Fulfilled", 140),
  moved: createDateColumn<Inventory>("moved", "Moved", 140),
} as const

export const getInventoryColumns = (): Column<Inventory>[] => {
  return Object.values(INVENTORY_COLUMNS)
}

export const getInventoryColumnConfig = (): ColumnManagementConfig[] => {
  return Object.entries(INVENTORY_COLUMNS).map(([key, col], index) => ({
    id: col.key,
    label: typeof col.header === 'string' ? col.header : col.key,
    visible: true,
    required: ['model', 'order'].includes(key),
    order: index
  }))
}